import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { ShowIf } from '../components/Security/security';

import ENSBorderLeft from '../assets/images/ENSBorderLeft.png';
import ENSBorderRight from '../assets/images/ENSBorderRight.png';
import ENSMainImage from '../assets/images/ENSMainImage.png';
import ENSIconSelfService from '../assets/images/ENSIconSelfService.png';
import ENSIconQuick from '../assets/images/ENSIconQuick.png';
import ENSIconFree from '../assets/images/ENSIconFree.png';

export default function LandingPage() {
  const navigate = useNavigate();
  const navigateToRegister = () => {
    navigate('./register');
  };

  return (
    <div className="main-container">
      <div>
        {/* Header */}
        <div className="banner-image-container">
          <img alt="left-border" src={ENSBorderLeft} className="banner-image-left-border" />
          <div className="banner-image">
            <p>ENS - Safety & Security Declaration</p>
            <h6>Submit your EU-GB safety and security declarations (ENS) on CABIE ENS</h6>
          </div>
          <img alt="right-border" src={ENSBorderRight} className="banner-image-right-border" />
        </div>
      </div>

      {/* Main Panel */}
      <div className="main-panel">
        <div className="main-panel-left">
          <p>
            CABIE ENS is a free to use service for EU to GB Roll On Roll Off movement of goods that require an GB Entry
            Security Declaration.
          </p>
          <p>
            <a href="#" onClick={navigateToRegister} style={{ color: 'inherit' }}>
              Sign up
            </a>{' '}
            to start creating your S&S GB ENS Declarations.
          </p>
          <ShowIf isLoggedIn={false}>
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 25 }}>
              <Button className="home-signup-button" onClick={navigateToRegister}>
                Sign Up
              </Button>
            </div>
          </ShowIf>
        </div>
        <div className="main-panel-right">
          <img alt="main" src={ENSMainImage} className="main-image" />
        </div>
      </div>

      {/* Icons Panel */}
      <div className="icons-panel-wrapper">
        <div className="icons-panel">
          <div className="icon-box">
            <img alt="icon" src={ENSIconSelfService} className="icon-image" />
            <h3>Self-Service</h3>
          </div>
          <div className="icon-box">
            <img alt="icon" src={ENSIconQuick} className="icon-image" />
            <h3>Quick and Easy</h3>
          </div>
          <div className="icon-box">
            <img alt="icon" src={ENSIconFree} className="icon-image" />
            <h3>Free To Use</h3>
          </div>
        </div>
      </div>
    </div>
  );
}
